<div class="step-total space-y-4" [formGroup]="formGroup">

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label class="block mb-1 text-sm font-medium text-gray-700">Valor do frete</label>
      <p-inputNumber
        formControlName="totalFreight"
        mode="currency"
        currency="BRL"
        locale="pt-BR"
        placeholder="0,00"
        class="w-full"
      ></p-inputNumber>
    </div>

    <div>
      <label class="block mb-1 text-sm font-medium text-gray-700">Seguro</label>
      <p-inputNumber
        formControlName="totalInsurance"
        mode="currency"
        currency="BRL"
        locale="pt-BR"
        placeholder="0,00"
        class="w-full"
      ></p-inputNumber>
    </div>

    <div>
      <label class="block mb-1 text-sm font-medium text-gray-700">Outras despesas</label>
      <p-inputNumber
        formControlName="totalOtherExpenses"
        mode="currency"
        currency="BRL"
        locale="pt-BR"
        placeholder="0,00"
        class="w-full"
      ></p-inputNumber>
    </div>

    <div>
      <label class="block mb-1 text-sm font-medium text-gray-700">Desconto no total</label>
      <p-inputNumber
        formControlName="discountOnTotal"
        mode="currency"
        currency="BRL"
        locale="pt-BR"
        placeholder="0,00"
        class="w-full"
      ></p-inputNumber>
    </div>

    <div class="md:col-span-2">
      <label class="block mb-1 text-sm font-medium text-gray-700">Observações</label>
      <textarea
        pInputTextarea
        formControlName="observations"
        rows="3"
        placeholder="Observações gerais da entrada..."
        class="w-full"
      ></textarea>
    </div>
  </div>
</div>
